import { CARE_GROUP_PREFIX_PATH, PUBLIC_HOST, USES_SUBDOMAIN } from "configs/AppConfig"

export const practicePathForSlug = (slug: string, directory = "", fullUrl = false) => {
  const path = USES_SUBDOMAIN ? `/${directory}` : `/${slug ? `${slug}/` : ""}${directory}`

  if (fullUrl) {
    let host = window.location.host

    if (slug && USES_SUBDOMAIN) {
      host = `${slug}.${PUBLIC_HOST}`
    }

    return `${window.location.protocol}//${host}${path}`
  }

  return path
}

export const careGroupPathForSlug = (slug: string, directory = "") => {
  // NOTE: Uses `CARE_GROUP_PREFIX_PATH` (even in production) to handle
  // conflicting routes with practice slugs
  const domain = "zorggroep"
  const host = USES_SUBDOMAIN ? `${domain}.${PUBLIC_HOST}` : window.location.host
  const path = `${CARE_GROUP_PREFIX_PATH}/${slug}`
  const nested = directory ? `/${directory}` : ""

  return `${window.location.protocol}//${host}${path}${nested}`
}
